var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.imageOriginal,"lazy-src":""}},[_c('canvas',{ref:'viewer',staticStyle:{"width":"100%","height":"100%","margin-bottom":"-8px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }